import React from "react";

function AppFooter() {
  return (
    <div
      className="
        fixed top-full w-[102vw] 
        -ml-[1vh] xl:mt-[-4.2vh] lg:mt-[-6vh] md:mt-[-7vh] mt-[-5vh]
        xl:h-[4.2vh] lg:h-[6vh] md:h-[7vh] h-[5vh] bg-black 
        "
    >
      <div className="text-white font-lato font-bold flex align-middle justify-center">
        <div className="py-[0.5vh] px-[0.5vh] text-center ">
          <h6 className="md:text-lg text-xs">
            Este serviço é autorizado pelas empresas contratantes. Pague Direto Serviços Financeiros. CNPJ:
            37.223.553/0001-13
          </h6>
        </div>
      </div>
    </div>
  );
}

export default AppFooter;
